let ModesConfig = {
    DEFAULT_MODE: 'FLEX',
    OVERALL_MODE: '*',
    CAPTAIN_MODE: 'CPT',
    STAR_MODE: 'STAR',
    PRO_MODE: 'PRO',
    FLEX_MODE: 'FLEX',
    EXCLUDED_MODE: 'excluded',
    LOCKED_MODE: 'locked',
    FAVORITE_MODE: 'my-players',

    MODES_CONFIG: {
        'single-game': {
            cfb: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'MVP',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'MVP',
                    getPropPrefix: () => 'captain_',
                    // isUsedInSalaryFilter: () => false,
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            nfl: {
                fanduel: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'MVP',
                        // getSalaryFilterLabel: () => '',
                        getSalaryFilterLabel: () => 'MVP',
                        getPropPrefix: () => 'captain_',
                        // isUsedInSalaryFilter: () => false,
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        // getSalaryFilterLabel: () => '',
                        getSalaryFilterLabel: () => 'FLEX',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
                yahoo: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'SUPERSTAR',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => false,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },

            nba: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'MVP',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'MVP',
                    getPropPrefix: () => 'captain_',
                    // isUsedInSalaryFilter: () => false,
                    isUsedInSalaryFilter: () => true,
                    // getPointCoefficient: () => 2,
                    getPointCoefficient: () => 1.5,
                },
                // STAR: {
                //     getRole: () => 'STAR',
                //     getLabel: () => 'STAR',
                //     getSalaryFilterLabel: () => '',
                //     getPropPrefix: () => 'star_',
                //     isUsedInSalaryFilter: () => false,
                //     getPointCoefficient: () => 1.5,
                // },
                // PRO: {
                //     getRole: () => 'PRO',
                //     getLabel: () => 'PRO',
                //     getSalaryFilterLabel: () => '',
                //     getPropPrefix: () => 'pro_',
                //     isUsedInSalaryFilter: () => false,
                //     getPointCoefficient: () => 1.2,
                // },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            nhl: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'MVP',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'MVP',
                    getPropPrefix: () => 'captain_',
                    // isUsedInSalaryFilter: () => false,
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            mlb: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'MVP',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'MVP',
                    getPropPrefix: () => 'captain_',
                    // isUsedInSalaryFilter: () => false,
                    isUsedInSalaryFilter: () => true,
                    // getPointCoefficient: () => 2,
                    getPointCoefficient: () => 1.5,
                },
                // STAR: {
                //     getRole: () => 'STAR',
                //     getLabel: () => 'STAR',
                //     getSalaryFilterLabel: () => '',
                //     getPropPrefix: () => 'star_',
                //     isUsedInSalaryFilter: () => false,
                //     getPointCoefficient: () => 1.5,
                // },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    // getSalaryFilterLabel: () => '',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
        },

        showdown: {
            cfb: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'CPT',
                    getSalaryFilterLabel: () => 'CPT',
                    getPropPrefix: () => 'captain_',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            golf: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            nfl: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'CPT',
                    getSalaryFilterLabel: () => 'CPT',
                    getPropPrefix: () => 'captain_',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            nba: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'CPT',
                    getSalaryFilterLabel: () => 'CPT',
                    getPropPrefix: () => 'captain_',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            nhl: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'CPT',
                    getSalaryFilterLabel: () => 'CPT',
                    getPropPrefix: () => 'captain_',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            mlb: {
                CPT: {
                    getRole: () => 'CPT',
                    getLabel: () => 'CPT',
                    getSalaryFilterLabel: () => 'CPT',
                    getPropPrefix: () => 'captain_',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1.5,
                },
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => 'FLEX',
                    getSalaryFilterLabel: () => 'FLEX',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },

            mma: {
                draftkings: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'CPT',
                        getSalaryFilterLabel: () => 'CPT',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => 'FLEX',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },
        },

        classic: {
            mlb: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nba: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nfl: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nhl: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            golf: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nascar: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            mma: {
                draftkings: {
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => '',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
                fanduel: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'MVP',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => false,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },
            cfb: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            lol: {
                draftkings: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'CPT',
                        getSalaryFilterLabel: () => 'CPT',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => 'FLEX',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
                fanduel: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'STAR',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => false,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },
            f1: {
                draftkings: {
                    CPT: {
                        getRole: () => 'CPT',
                        getLabel: () => 'CPT',
                        getSalaryFilterLabel: () => 'CPT',
                        getPropPrefix: () => 'captain_',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1.5,
                    },
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => 'FLEX',
                        getSalaryFilterLabel: () => 'FLEX',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },
            tennis: {
                draftkings: {
                    FLEX: {
                        getRole: () => 'FLEX',
                        getLabel: () => '',
                        getSalaryFilterLabel: () => '',
                        getPropPrefix: () => '',
                        isUsedInSalaryFilter: () => true,
                        getPointCoefficient: () => 1,
                    },
                },
            },
        },

        tiers: {
            nba: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nfl: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            mlb: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            nhl: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
            golf: {
                FLEX: {
                    getRole: () => 'FLEX',
                    getLabel: () => '',
                    getSalaryFilterLabel: () => '',
                    getPropPrefix: () => '',
                    isUsedInSalaryFilter: () => true,
                    getPointCoefficient: () => 1,
                },
            },
        },
    },
};

export default ModesConfig;
